"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect } from "react";
import { useMe } from "@/hooks/useMe";
const PYLON_APP_ID = process.env.NEXT_PUBLIC_PYLON_APP_ID;
export function PylonProvider() {
  const $ = _c(5);
  const {
    me,
    isLoading
  } = useMe();
  let t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== me) {
    t0 = () => {
      if (typeof window === "undefined" || isLoading || !me) {
        return;
      }
      if (window.Pylon && window.pylon) {
        window.Pylon("setNewIssueCustomFields", {
          document_crunch_version: "2_0"
        });
        window.Pylon("setTicketFormFields", {
          document_crunch_version: "2_0"
        });
        const {
          firstName,
          lastName,
          email
        } = me.data.attributes;
        const fullName = firstName && lastName ? `${firstName} ${lastName}`.trim() : email;
        window.pylon.chat_settings = {
          ...window.pylon?.chat_settings,
          email,
          email_hash: me.meta?.pylonEmailHash,
          name: fullName
        };
      }
    };
    t1 = [me, isLoading];
    $[0] = isLoading;
    $[1] = me;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  if (!PYLON_APP_ID) {
    return null;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Script id="dc-pylon" strategy="lazyOnload">{`
      (function() {
        var e=window;var t=document;var n=function(){n.e(arguments)};n.q=[];n.e=function(e){n.q.push(e)};e.Pylon=n;var r=function(){var e=t.createElement("script");e.setAttribute("type","text/javascript");e.setAttribute("async","true");e.setAttribute("src","https://widget.usepylon.com/widget/${PYLON_APP_ID}");var n=t.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};if(t.readyState==="complete"){r()}else if(e.addEventListener){e.addEventListener("load",r,false)};

        window.pylon = {
          chat_settings: {
            app_id: '${PYLON_APP_ID}',
          },
        };
      })();
    `}</Script>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}